module.exports = "/work-site/img/video.67a1741c.png";